import { CustomFormatPipe } from 'src/shared/pipes';

export interface ISecurityDetailResponse {
  open_price: number;
  close_price: number;
  security_id: string;
  issuer: string;
  max_price: number;
  min_price: number;
  variation_percentage: number;
  weighted_average_price: number;
  highest_price_in_fifty_two_weeks: number;
  lowest_price_in_fifty_two_weeks: number;
  last_price: number;
  volume_in_six_months: string;
  volume: string;
}

export interface ISecurityDetailDigitalResponse {
  apertura: number;
  cierre_Ant: number;
  emisora: string;
  emisoraNombre: string;
  maximo: number;
  minimo: number;
  porcent_Cambio: number;
  ppp: number;
  precioMax52Sem: number;
  precioMin52Sem: number;
  ultimo: number;
  volumenOper6M: string;
  volumen_Oper: string;
}

export interface ISecurityDetail {
  openPrice: number;
  closePrice: number;
  securityId: string;
  issuer: string;
  maxPrice: number;
  minPrice: number;
  variationPercentage: number;
  weightedAveragePrice: number;
  highestPriceInFiftyTwoWeeks: number;
  lowestPriceInFiftyTwoWeeks: number;
  lastPrice: number;
  volumeInSixMonths: string;
  volume: string;
}

export class SecurityDetailViewModel implements ISecurityDetail {
  private pipe: CustomFormatPipe = new CustomFormatPipe();

  static fromJSON(json: ISecurityDetailResponse): SecurityDetailViewModel {
    return new SecurityDetailViewModel(
      json.open_price,
      json.close_price,
      json.security_id,
      json.issuer,
      json.max_price,
      json.min_price,
      json.variation_percentage,
      json.weighted_average_price,
      json.highest_price_in_fifty_two_weeks,
      json.lowest_price_in_fifty_two_weeks,
      json.last_price,
      json.volume_in_six_months,
      json.volume,
    );
  }

  static fromDigitalJSON(
    json: ISecurityDetailDigitalResponse,
  ): SecurityDetailViewModel {
    return new SecurityDetailViewModel(
      json.apertura,
      json.cierre_Ant,
      json.emisora,
      json.emisoraNombre,
      json.maximo,
      json.minimo,
      json.porcent_Cambio,
      json.ppp,
      json.precioMax52Sem,
      json.precioMin52Sem,
      json.ultimo,
      json.volumenOper6M,
      json.volumen_Oper,
    );
  }

  constructor(
    public openPrice: number,
    public closePrice: number,
    public securityId: string,
    public issuer: string,
    public maxPrice: number,
    public minPrice: number,
    public variationPercentage: number,
    public weightedAveragePrice: number,
    public highestPriceInFiftyTwoWeeks: number,
    public lowestPriceInFiftyTwoWeeks: number,
    public lastPrice: number,
    public volumeInSixMonths: string,
    public volume: string,
  ) {
    this.volume = this.formatVolume(this.volume);
    this.volumeInSixMonths = this.formatVolume(this.volumeInSixMonths);
    this.variationPercentage =
      this.variationPercentage !== 0
        ? this.pipe.transform(this.variationPercentage, '0[.]00')
        : '-';
  }

  private formatVolume(value: any): string {
    let formatedValue: string = this.pipe.transform(value, '0.0a');
    const strLength: number = formatedValue.length - 1;
    if (formatedValue.match(/[a-z]/i)) {
      formatedValue =
        formatedValue.substring(0, strLength) +
        formatedValue.charAt(strLength).toUpperCase();
    }
    return value !== '' ? formatedValue : '-';
  }
}
